import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { AnnouncementComponent } from './announcement.component';
import { BaseModule } from '@sb/library/base';

@NgModule({
    declarations: [
        AnnouncementComponent
    ],
    imports: [
        CommonModule,
        IconModule,
        ButtonModule,
        BaseModule
    ],
    exports: [
        AnnouncementComponent
    ]
})
export class AnnouncementModule { }
